import { ORDER_TYPES } from '@exodus/fiat-client'
import { memoize } from 'lodash' // eslint-disable-line @exodus/restricted-imports/prefer-basic-utils -- TODO: fix next time we touch this file

const resultFunction = (assets) =>
  memoize((assetName, orderType) =>
    Object.values(assets[assetName]?.providers || {}).some(
      (provider) => provider[orderType === ORDER_TYPES.buy ? 'isBuySupported' : 'isSellSupported']
    )
  )

const isAssetSupportedByOrderTypeSelectorDefinition = {
  id: 'isAssetSupportedByOrderType',
  resultFunction,
  dependencies: [{ selector: 'assetData' }],
}

export default isAssetSupportedByOrderTypeSelectorDefinition
